import React from 'react';
import * as PropTypes from 'prop-types';

import { Link } from '../../router';
import R from '../../lib/routes';
import { classNamer, classes, truncateText } from '../../lib/utils';
import Details from '../widgets/Details';
import ProgressiveLoadingImage from '../widgets/ProgressiveLoadingImage';

import './BlogArticleCard.scss';

const cn = classNamer('BlogArticleCard');

const BlogArticleCard = ({ article }) => {
  return (
    <div className={`${classes(cn())} magnify`}>
      <Link route={R.blogArticle(article)}>
        <a>
          <ProgressiveLoadingImage
            className={classes(cn('preview-image'))}
            image={article.preview_image}
          />

          <div className={cn('content')}>
            <h2 className={cn('title')}>{article.title}</h2>

            <Details item={article} />

            <div className={cn('summary')}>{truncateText(article.summary, 30)}</div>
          </div>
        </a>
      </Link>
    </div>
  );
};

BlogArticleCard.propTypes = {
  article: PropTypes.object,
};

export default BlogArticleCard;
